export const GERAR_BOLETO = "GERAR_BOLETO";
export const GERAR_BOLETO_SUCCESS = "GERAR_BOLETO_SUCCESS";
export const GERAR_BOLETO_START = "GERAR_BOLETO_START";
export const GERAR_BOLETO_FAIL = "GERAR_BOLETO_FAIL";
